
export const CHANGE_VIDEODATA = 'sideBar/change_video_data'
export const CHANGE_COURSEWAREDATA = 'sideBar/change_courseware_data'
export const CHANGE_QUESTIONDATA = 'sideBar/change_question_data'

